export const cubeFactTablePageSize = 5;
